import { render, staticRenderFns } from "./EstimateFeeScheduleModal.vue?vue&type=template&id=0535d9b6&scoped=true"
import script from "./EstimateFeeScheduleModal.vue?vue&type=script&lang=js"
export * from "./EstimateFeeScheduleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535d9b6",
  null
  
)

export default component.exports